//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

/* DEPRECATED */
(() => {
    // This filter no longer does anything but passthrough
    // the value provided. Emoji are now officially supported
    // in all major browsers and OSes, so we no longer include
    // twemoji as a dependency.
    //
    // This filter can be removed when we no longer use
    // the "{{ ... | emoji }}" filter in our angular templates.
  angular.module('curalate').filter('emoji', [() => {
    return function(input) {
      return input;
    };
  }]);
})();
